import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {METERS_PER_KILOMETER, METERS_PER_MILE} from "../../utils/distance-unit.util";


export class CurrencyInputSiteDistanceToMeterCtrl implements IController {
  value: number;
  min: number;
  addStepToMin: boolean;
  max: number;
  step: number;
  formName: string;
  isRequired: boolean;
  label: string | undefined;
  onChange: Function;

  public siteDistanceUnit: string;

  public shortenCalculatedValue: number;
  public calculatedMin: number;
  public calculatedMax: number;


  /* @ngInject */
  constructor(private splitService, private $filter) {
    this.siteDistanceUnit = splitService.getSiteDistanceLargeUnit(true);
  }

  $onInit() {
    this.shortenCalculatedValue = !_.isUndefined(this.value) ? +(this.$filter('priceByMeterToSiteDistance')(this.value)) : undefined;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if ((changes.value && !changes.value.isFirstChange()) ||
      (changes.min && !changes.min.isFirstChange()) ||
      (changes.max && !changes.max.isFirstChange())) {
      this.$onInit();
    }
  }

  public valueChanged(shortenCalculatedValue) {
    let value;
    switch (this.siteDistanceUnit) {
      case 'KM': {
        value = !_.isNil(shortenCalculatedValue) ? shortenCalculatedValue / METERS_PER_KILOMETER : undefined;
        break;
      }
      case 'MI': {
        value = !_.isNil(shortenCalculatedValue) ? shortenCalculatedValue / METERS_PER_MILE : undefined;
        break;
      }
    }
    this.onChange({value: value});
  }

}

angular
  .module('bringoz.admin.commons')
  .component('currencyInputSiteDistanceToMeter', {
    require: {
      form: '^form'
    },
    bindings: {
      value: '<',
      min: '<',
      addStepToMin: '<?',
      max: '<',
      isRequired: '<?',
      label: '<?',
      formName: '@',
      onChange: '&'
    },
    template: require('./currency-input-site-distance-to-meter.html').default,
    controller: CurrencyInputSiteDistanceToMeterCtrl
  });
